package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import org.moxultimate.topwithmox.components.layouts.PageLayoutData
import org.moxultimate.topwithmox.components.restricted.RestrictedPage
import org.moxultimate.topwithmox.core.toggle.FeatureToggle
import org.moxultimate.topwithmox.productcrud.main.ProductCRUDPage

@InitRoute
fun initProductCRUDRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Product Content CRUD"))
}

/**
 * ProductCRUDRoute
 * Renders [ProductCRUDPage] when [FeatureToggle.PRODUCT_CRUD_TOGGLE] is enabled,
 * otherwise shows [RestrictedPage].
 */
@Page(routeOverride = "products-crud")
@Layout(".components.layouts.PageLayout")
@Composable
fun ProductCRUDRoute() {
    if (FeatureToggle.PRODUCT_CRUD_TOGGLE) ProductCRUDPage() else RestrictedPage()
}
